





























import Vue, {PropType} from 'vue'
import {Ssp} from '@/types'

export default Vue.extend({
    name: 'ViewCreativeTemplate',
    props: {
        ssp: {
            type: Object as PropType<Ssp>
        }
    },
})
